import _app from "../../../views/_app.tsx";

/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "404": dynamic(() => import("../../../views/404.tsx"), "views/404.tsx"),
  "_app": _app,
  "front-page": dynamic(() => import("../../../views/front-page.tsx"), "views/front-page.tsx"),
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "single": dynamic(() => import("../../../views/single.tsx"), "views/single.tsx"),
  "template-holding-page": dynamic(
    () => import("../../../views/template-holding-page.tsx"),
    "views/template-holding-page.tsx",
  ),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
